import React from 'react';
import BaseForm from './form'; 
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

// const cheat = {
// 	isLoggedIn: false
//       };

function Form()  {
	return (
		<div style={{}}>
			<Card
				style={{
				width: 800,
				backgroundColor: "#ffffeh",
				}}
			>
				<CardContent>
					{/* <h1> Base Form </h1> */}
					<div className="container">
						<div className="row align-items-center my-5">
							<BaseForm isLoggedIn = "False"/>
							<br />
						</div>
					</div>
				</CardContent>
			</Card>
		</div>
	)
}

export default Form  ; //new